import useProtectedQuery from './use-protected-query';

import RebatesClient from '../RebatesClient';

/**
 * Fetches the eligible parent/child accounts for the statement builder from
 * GET /api/report/statement-builder-accounts.
 *
 * Returns the normalized shape:
 *   accounts: [{ id, name, rewardsCode, farms: [{ id, name, rewardsCode }] }]
 */
export default function useStatementBuilderAccounts() {
  const {
    data: accounts,
    isLoading: accountsLoading,
    error: accountsError,
    refetch: refetchAccounts
  } = useProtectedQuery({
    queryKey: ['statement_builder_accounts'],
    queryFn: async () => {
      const result = await RebatesClient.standardFetch('/api/report/statement-builder-accounts');

      if (result.response.ok) {
        return result.body?.accounts || [];
      }
      throw new Error('Error getting statement builder accounts');
    }
  });

  return {
    accounts: accounts || [],
    accountsLoading,
    accountsError,
    refetchAccounts
  };
}
